<template>
    <div class="home">
        <header-bar></header-bar>
        <div class="page-container" >
            <el-row class="flex">
                <el-col :xs="24" :sm="3" :md="3" :lg="3"  class="l-menu">
                    <main-menu></main-menu>
                    <!-- <p>uuu</p> -->
                </el-col>
                <el-col :xs="24" :sm="21" :md="21" :lg="21">
                    <div class="grid-content r-con" style="background-color:#F5F5F5">
                        <router-view></router-view>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!--
        <footer id="footer">
            <p>webui</p>
        </footer>
        -->
    </div>
</template>

<script>
    export default {
        name: 'home',
        data() {
            return {
                home: 'webui home'
            }
        },
        mounted() {
        },
        watch: {
        },
        methods: {
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.flex{
 display: flex;
//  width: 100%;
 
 .r-con{
//    width: calc(100% - 256px);
 }
}
.l-menu{
  background: #009E7D;
//   width: 256px;
}
</style>



// WEBPACK FOOTER //
// home.vue?147d3878